import brandBuilderEditor from '@/store/modules/brand-builder-editor';

const { mutations } = brandBuilderEditor;
const mutationsAllowedToBeSaved = Object.keys(mutations);
const setUserProfileMutationLabel = 'SET_USER_PROFILE'; // we are tracking this mutation bc that is what's called after ADFS token is retrieved
const brandBuilderStateKey = 'brandBuilderState';

const persistData = (store) => {
	/*
		@param mutation = { type, payload }, state = { // store module }
		Subscribe to the store so that we can track mutations that we commit. We are destructuring the type property
		from the param mutation which is an object. Type is a string and is the mutation labels we really are tracking
	 */
	store.subscribe(({ type }, state) => {
		if (mutationsAllowedToBeSaved.includes(type)) {
			const record = { data: state.brandBuilderEditor };

			try {
				localStorage.setItem(brandBuilderStateKey, JSON.stringify(record));
			} catch (error) {}
		}

		if (setUserProfileMutationLabel === type) {
			let storage = false;

			try {
				storage = localStorage.getItem(brandBuilderStateKey) || false;

				if (storage) {
					storage = JSON.parse(storage);
					store.commit('SET_BRANDBUILDER_STATE', storage.data);
					localStorage.removeItem(brandBuilderStateKey);
				}
			} catch (error) {}
		}
	});
};

export default persistData;
